import { cn } from "@/lib/utils";
import { StopModel } from "@/models/stop.model";
import { FaPersonWalking } from "react-icons/fa6";

export default function ProgressBarWithTicks({
  stops,
  activeStop,
  // onTickClick,
}: {
  stops: StopModel[];
  activeStop: number;
  // onTickClick: (tick: number) => void;
}) {
  return (
    <div className="mx-auto mt-4 w-full">
      {/* Progress Bar Container */}
      <div className="relative h-2 w-full rounded-full bg-primary/20">
        {/* Progress */}
        <div
          className="absolute left-0 top-0 h-full bg-primary transition-all"
          style={{
            width: `${(activeStop / (stops.length - 1)) * 100}%`,
          }}
        ></div>

        {/* Ticks */}
        <div className="absolute top-[-9px] flex w-full justify-between">
          {stops.map((stop, index) => (
            <div
              key={stop.id}
              className="relative flex cursor-default flex-col items-center"
              // onClick={() => onTickClick(index)} // Handle tick click
            >
              {/* Circle */}
              <div
                className={cn(
                  "flex h-6 w-6 items-center justify-center rounded-full text-xs font-bold text-white transition-all",
                  index === activeStop ? "bg-black" : "bg-primary",
                  index === 0 && "-ml-1",
                  index === stops.length - 1 && "-mr-1",
                )}
              >
                {index === activeStop ? <FaPersonWalking /> : `${index + 1}`}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
